import { render, staticRenderFns } from "./TalkList.vue?vue&type=template&id=380d6a39&scoped=true"
import script from "./TalkList.vue?vue&type=script&lang=js"
export * from "./TalkList.vue?vue&type=script&lang=js"
import style0 from "./TalkList.vue?vue&type=style&index=0&id=380d6a39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d6a39",
  null
  
)

export default component.exports